import React from 'react';
import { Link, useHistory } from "react-router-dom"
// import { COLOR_GREENISH } from '../../utils/constants';
// import styles from './styles'
// import logo from '../../res/logo.png'
// import { Image } from "react-bootstrap"

export default function PrivacyPolicy() {

const termsLink = <Link to="/terms-of-service" target={'blank'} style={{display: 'inline-block'}}>
                    <p style={{margin: 0}}>Terms of Service</p>
                  </Link>


  return (
    <>
  <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
  <title>Microsoft Word - Phone List - Privacy Policy.docx</title>
  <style
    type="text/css"
    dangerouslySetInnerHTML={{
      __html:
        ' * {margin:0; padding:0; text-indent:0; }\n h1 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }\n .s1 { color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt; }\n .p, p { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; margin:0pt; }\n h2 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n .h4 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 9pt; }\n .s2 { color: #0563C1; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 12pt; }\n .h3 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 9.5pt; }\n .s3 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n .a { color: #0563C1; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 12pt; }\n li {display: block; }\n #l1 {padding-left: 0pt;counter-reset: c1 1; }\n #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, decimal)". "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }\n li {display: block; }\n #l2 {padding-left: 0pt;counter-reset: d1 1; }\n #l2> li>*:first-child:before {counter-increment: d1; content: counter(d1, decimal)". "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }\n #l2> li:first-child>*:first-child:before {counter-increment: d1 0;  }\n #l3 {padding-left: 0pt; }\n #l3> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n'
    }}
  />
  <h1
    style={{
      paddingTop: "3pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    PHONE LIST PRIVACY POLICY
  </h1>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s1"
    style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
  >
    Effective as of February 14, 2022
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <h1 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
    Introduction
  </h1>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
    The Talent Match Group (“TMG,” “we,” “our,” or “us”) respects the privacy of
    your information. This Privacy Policy is designed to assist you in
    understanding how we collect, use and safeguard the information you provide
    to us in using our mobile application (“App”) and the services provided
    through our App (the, “Services”).
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
    From time to time, we may change this Privacy Policy. If we do, we will post
    an amended version on this webpage. Please review this Privacy Policy
    periodically.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
    This Privacy Policy covers the following topics:
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <ol id="l1">
    <li data-list-text={1}>
      <h2
        style={{ paddingLeft: "27pt", textIndent: "-22pt", textAlign: "left" }}
      >
        Collecting and Using Information
      </h2>
    </li>
    <li data-list-text={2}>
      <h2
        style={{
          paddingTop: "7pt",
          paddingLeft: "27pt",
          textIndent: "-22pt",
          textAlign: "left"
        }}
      >
        In-App Tracking Technologies
      </h2>
    </li>
    <li data-list-text={3}>
      <h2
        style={{
          paddingTop: "6pt",
          paddingLeft: "27pt",
          textIndent: "-22pt",
          textAlign: "left"
        }}
      >
        Third Party Processors
      </h2>
    </li>
    <li data-list-text={4}>
      <h2
        style={{
          paddingTop: "7pt",
          paddingLeft: "27pt",
          textIndent: "-22pt",
          textAlign: "left"
        }}
      >
        Choices About Your Personally Identifiable Information
      </h2>
    </li>
    <li data-list-text={5}>
      <h2
        style={{
          paddingTop: "6pt",
          paddingLeft: "27pt",
          textIndent: "-22pt",
          textAlign: "left"
        }}
      >
        S<span className="h4">ECURITY</span>
      </h2>
    </li>
    <li data-list-text={6}>
      <h2
        style={{
          paddingTop: "6pt",
          paddingLeft: "27pt",
          textIndent: "-22pt",
          textAlign: "left"
        }}
      >
        Third Party Links
      </h2>
    </li>
    <li data-list-text={7}>
      <h2
        style={{
          paddingTop: "7pt",
          paddingLeft: "27pt",
          textIndent: "-22pt",
          textAlign: "left"
        }}
      >
        Children’s Privacy
      </h2>
    </li>
    <li data-list-text={8}>
      <h2
        style={{
          paddingTop: "6pt",
          paddingLeft: "27pt",
          textIndent: "-22pt",
          textAlign: "left"
        }}
      >
        Notice to Nevada Residents
      </h2>
    </li>
    <li data-list-text={9}>
      <h2
        style={{
          paddingTop: "7pt",
          paddingLeft: "27pt",
          textIndent: "-22pt",
          textAlign: "left"
        }}
      >
        Notice to California Residents
      </h2>
    </li>
    <li data-list-text={10}>
      <h2
        style={{
          paddingTop: "6pt",
          paddingLeft: "38pt",
          textIndent: "-33pt",
          textAlign: "left"
        }}
      >
        How to Contact Us
      </h2>
    </li>
  </ol>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <ol id="l2">
    <li data-list-text={1}>
      <h1
        style={{
          paddingTop: "6pt",
          paddingLeft: "23pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Collecting and Using Information
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h1 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
        Personally Identifiable Information We Collect Online
      </h1>
      <p
        style={{
          paddingTop: "11pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        We collect Personally Identifiable Information from you through your use
        of the App and Services. “Personally Identifiable Information” is
        individually identifiable information about an individual consumer that
        we collect online and that we maintain in an accessible form. We collect
        the following types of Personally Identifiable Information:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s1"
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}
      >
        Information You Provide
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        We may collect the following Personally Identifiable Information that
        you voluntarily provide to us:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <ul id="l3">
        <li data-list-text="">
          <p
            className="s1"
            style={{
              paddingTop: "5pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Business or Employer Sign Up
            <span className="p">
              . When you sign up as a registered business or employer, you will
              provide us with your name, phone number, email address, and
              company title or role.
            </span>
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s1"
            style={{
              paddingTop: "3pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            Employee Photo Request and Sign Up.{" "}
            <span className="p">
              If your employer requests that you use the Services, you will
              provide us with a photograph of yourself, your name, phone number,
              department and position.
            </span>
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s1"
            style={{
              paddingLeft: "41pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Information as You Navigate Our App
          </p>
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            We automatically collect certain Personally Identifiable Information
            through your use of the App and Services, such as the following:
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s1"
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Usage Information
            <span className="p">
              . For example, pages on the App you access, the frequency of
              access, and what you click on while on the App.
            </span>
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s1"
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Device Information.{" "}
            <span className="p">
              For example, hardware model, operating system, application version
              number, and browser.
            </span>
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s1"
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Mobile Device Information
            <span className="p">
              . Aggregated information about whether the App is accessed via a
              mobile device or tablet, the device type, and the carrier.
            </span>
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s1"
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Location Information
            <span className="p">
              . Location information from App visitors on a city-regional basis.
            </span>
          </p>
          <p
            className="s1"
            style={{
              paddingTop: "12pt",
              paddingLeft: "41pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Third Party Information
          </p>
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            In some cases, we may receive certain Personally Identifiable
            Information from you about a third party. For example, as part of
            our business or employer sign up process, you may provide the name,
            phone number, email address, and company title or role of a third
            party. If you submit any Personally Identifiable Information about
            another individual to us, you are responsible for making sure that
            you have the authority to do so and to allow us to use their
            Personally Identifiable Information in accordance with this Privacy
            Policy.
          </p>
          <h1
            style={{
              paddingTop: "11pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            How We Use Your Personally Identifiable Information
          </h1>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            We use the Personally Identifiable Information we collect to provide
            the Services to you, to improve our Services and App, and to protect
            our legal rights. In addition, we may use the Personally
            Identifiable Information we collect to:
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Process your account registration;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Add employee contact information to business or employer dashboards;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Allow registered businesses or employers to send call and text
            updates to their employees;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "12pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            If you are an employee, to contact you regarding your employment
            status with your registered business or employer in order to
            maintain an updated database;
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Communicate with you about our App or Services or to inform you of
            any changes to our App or Services;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "3pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Provide support;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Maintain and improve our App and Services;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Defend our legal rights and the rights of others;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Efficiently maintain our business; and
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Comply with applicable law.
          </p>
          <h1
            style={{
              paddingTop: "12pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            How We Share Your Personally Identifiable Information
          </h1>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            We may share the information that we collect about you in the
            following ways:
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            If you are an employee using the App, we will share certain
            Personally Identifiable Information with the managers or
            administrators of the registered business or employer;
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            With service providers who perform data or App-related services on
            our behalf (e.g., email, hosting, maintenance, backup, analysis,
            etc.). Any such service providers will be under an obligation to us
            to maintain the confidentiality of your Personally Identifiable
            Information;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            To service providers to prepare, deploy and analyze advertising
            content;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            To the extent that we are required to do so by law;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            In connection with any legal proceedings or prospective legal
            proceedings;
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            To establish, exercise, or defend our legal rights, including
            providing information to others for the purposes of fraud
            prevention;
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            To any person who we reasonably believe may apply to a court or
            other competent authority for disclosure of that Personally
            Identifiable Information where, in our reasonable opinion, such
            court or authority would be reasonably likely to order disclosure of
            that Personally Identifiable Information;
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "justify"
            }}
          >
            To any other person or entity as part of any business or asset sale,
            equity transaction, merger, acquisition or in preparation for any of
            these events; and
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingTop: "11pt",
              paddingLeft: "41pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            To any other person or entity where you consent to the disclosure.
          </p>
        </li>
      </ul>
    </li>
    <li data-list-text={2}>
      <h1
        style={{
          paddingTop: "12pt",
          paddingLeft: "23pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        In-App Tracking Technologies
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "114%",
          textAlign: "justify"
        }}
      >
        Like many other companies, we use a variety of tracking technologies
        that may include device identifiers, or other identifiers such as “Ad
        IDs.” For more information on mobile specific opt-out choices, visit the{" "}
        <span className="s2">
          Network Advertising Initiative's Mobile Choices Website
        </span>
        .
      </p>
    </li>
    <li data-list-text={3}>
      <h1
        style={{
          paddingTop: "10pt",
          paddingLeft: "23pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Third Party Processors
      </h1>
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        To ensure that your Personally Identifiable Information receives an
        adequate level of protection, we have put in place appropriate
        procedures with the service providers we share it with to ensure that it
        is treated consistent with applicable data security and privacy laws.
        For example, we use cloud data storage, accounting software, payment
        processors, and marketing service providers.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={4}>
      <h1
        style={{
          paddingLeft: "5pt",
          textIndent: "0pt",
          lineHeight: "186%",
          textAlign: "left"
        }}
      >
        C<span className="h3">HOICES </span>A<span className="h3">BOUT </span>Y
        <span className="h3">OUR </span>P<span className="h3">ERSONALLY </span>I
        <span className="h3">DENTIFIABLE </span>I
        <span className="h3">NFORMATION </span>Review and Request Changes to
        Your Personally Identifiable Information
      </h1>
      <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
        <a href="mailto:admin@phone-list.com" className="s3" target="_blank">
          To review or request changes to any of your Personally Identifiable
          Information, please contact us at admin@phone-list.com.
        </a>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h1 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
        Marketing Communications
      </h1>
      <p
        style={{
          paddingTop: "11pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        <a href="mailto:admin@phone-list.com" className="s3" target="_blank">
          To unsubscribe from our marketing emails, please click the unsubscribe
          link included in the footer of our emails. You also may submit a
          request to us at{" "}
        </a>
        <a href="mailto:admin@phone-list.com" className="a" target="_blank">
          admin@phone-list.com
        </a>
        <a href="mailto:admin@phone-list.com" className="s3" target="_blank">
          .
        </a>
      </p>
    </li>
    <li data-list-text={5}>
      <h1
        style={{
          paddingTop: "11pt",
          paddingLeft: "23pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        S<span className="h3">ECURITY</span>
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        We maintain commercially reasonable security measures to protect the
        Personally Identifiable Information we collect and store from loss,
        misuse, destruction, or unauthorized access. However, no security
        measure or modality of data transmission over the Internet is 100%
        secure. Although we strive to use commercially acceptable means to
        protect your Personally Identifiable Information, we cannot guarantee
        absolute security.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={6}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Third Party Links
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        The App and Services may contain links that will let you leave the App
        and Services and access another website. Linked websites are not under
        our control. This Privacy Policy applies solely to Personally
        Identifiable Information that is acquired by us on this App and
        Services. We accept no responsibility or liability for these other
        websites.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={7}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Children’s Privacy
      </h1>
      <p
        style={{
          paddingTop: "11pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        The App and Services are not intended for children under 13 years of
        age. We do not knowingly collect, use, or disclose personal information
        from children under 13.
      </p>
    </li>
    <li data-list-text={8}>
      <h1
        style={{
          paddingTop: "11pt",
          paddingLeft: "23pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Notice to Nevada Residents
      </h1>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        <a href="mailto:admin@phone-list.com" className="s3" target="_blank">
          Nevada law allows Nevada residents to opt-out of the sale of certain
          types of personal information. Subject to several exceptions, Nevada
          law defines “sale” to mean the exchange of certain types of personal
          information for monetary consideration to another person. We do not
          currently sell personal information as defined in the Nevada law.
          However, if you are a Nevada resident, you still may submit a verified
          request to opt-out of sales and we will record your instructions and
          incorporate them in the future if our policy changes. Opt-out requests
          may be sent to{" "}
        </a>
        <a href="mailto:admin@phone-list.com" className="a" target="_blank">
          admin@phone-list.com
        </a>
        <a href="http://www.phone-list.com/" className="s3" target="_blank">
          , 806-503-4012, or{" "}
        </a>
        <a href="http://www.phone-list.com/" className="a" target="_blank">
          www.phone-list.com
        </a>
        <a href="http://www.phone-list.com/" className="s3" target="_blank">
          .
        </a>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={9}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Notice to California Residents
      </h1>
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        We do not disclose personal information obtained through our App or
        Services to third parties for their direct marketing purposes.
        Accordingly, we have no obligations under California Civil Code
      </p>
      <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
        § 1798.83.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={10}>
      <h1
        style={{ paddingLeft: "23pt", textIndent: "-18pt", textAlign: "left" }}
      >
        How to Contact Us
      </h1>
    </li>
  </ol>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
    <a href="mailto:admin@phone-list.com" className="s3" target="_blank">
      To contact us for questions or concerns about our privacy policies or
      practices please email us at{" "}
    </a>
    <a href="mailto:admin@phone-list.com" className="a" target="_blank">
      admin@phone-list.com
    </a>
    <a href="mailto:admin@phone-list.com" className="s3" target="_blank">
      .
    </a>
  </p>
</>
  );
}